<script setup lang="ts">
interface HeroMeta {
  label: string
  value: string
  suffix: string
}

const heroMeta: HeroMeta[] = [
  { label: 'Realizacje', value: '4 217', suffix: '+' },
  { label: 'Średni czas', value: '14', suffix: 'dni' },
  { label: 'Gwarancja', value: '5', suffix: 'lat' },
]
</script>

<template>
  <header
    id="hero"
    class="border-pw-line bg-pw-ink relative overflow-hidden border-b"
  >
    <span
      class="border-pw-yellow pointer-events-none absolute top-4 left-4 size-3.5 border border-r-0 border-b-0"
    ></span>
    <span
      class="border-pw-yellow pointer-events-none absolute top-4 right-4 size-3.5 border border-b-0 border-l-0"
    ></span>

    <div
      class="relative z-[2] mx-auto max-w-[1440px] px-5 py-5 md:px-14 md:pt-10"
    >
      <div class="hero-grid grid min-h-[480px] items-center gap-0">
        <div class="sm:pb-0 md:pb-5">
          <h1
            class="font-narrow m-0 mb-7 text-[clamp(56px,8vw,112px)] leading-[0.92] font-extrabold tracking-[-0.025em] text-balance"
          >
            Zbuduj <em class="text-pw-orange inline-block not-italic">swój</em>
            <br />
            pojazd
            <span
              class="text-pw-muted decoration-pw-yellow line-through decoration-[6px]"
            >
              w&nbsp;tygodnie</span
            ><br />
            <em class="text-pw-orange inline-block not-italic">w 8 minut.</em>
          </h1>

          <p
            class="text-pw-muted m-0 mb-9 max-w-[460px] text-[18px] leading-[1.45]"
          >
            Konfigurator zabudów do samochodów dostawczych i ciężarowych.
            Wybierasz, dopasowujesz, zatwierdzasz — my budujemy. Bez handlowca,
            bez czekania na ofertę.
          </p>

          <div class="mb-11 flex items-center gap-3">
            <a
              href="#config"
              class="bg-pw-orange text-pw-paper hover:bg-pw-yellow inline-flex cursor-pointer items-center gap-2.5 rounded-[2px] px-7 py-[18px] text-[16px] font-semibold no-underline transition-all"
            >
              Rozpocznij konfigurację
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </a>
            <a
              href="#process"
              class="bg-pw-line text-pw-ink hover:border-pw-paper inline-flex cursor-pointer items-center gap-2.5 rounded-[2px] border border-[#2a2e36] px-7 py-[18px] text-[16px] font-semibold no-underline transition-all hover:bg-[#a59e8b]"
            >
              Zobacz jak to działa
            </a>
          </div>

          <dl
            class="border-pw-line grid max-w-[540px] grid-cols-[repeat(3,auto)] gap-9 border-t pt-6"
          >
            <div v-for="m in heroMeta" :key="m.label">
              <dt
                class="text-pw-muted mb-1.5 font-mono text-[10px] tracking-[0.12em] uppercase"
              >
                {{ m.label }}
              </dt>
              <dd class="font-narrow m-0 text-[28px] font-bold tracking-tight">
                {{ m.value }}&nbsp;<em class="text-pw-orange not-italic">{{
                  m.suffix
                }}</em>
              </dd>
            </div>
          </dl>
        </div>

        <div class="relative hidden items-end justify-end self-stretch md:flex">
          <div class="hero-photo absolute inset-0"></div>
        </div>
      </div>
    </div>

    <span
      class="border-pw-yellow pointer-events-none absolute bottom-4 left-4 size-3.5 border border-t-0 border-r-0"
    ></span>
    <span
      class="border-pw-yellow pointer-events-none absolute right-4 bottom-4 size-3.5 border border-t-0 border-l-0"
    ></span>
  </header>
</template>

<style scoped>
.hero-grid {
  grid-template-columns: 1.05fr 1fr;
}

@media (max-width: 1100px) {
  .hero-grid {
    grid-template-columns: 1fr;
  }
}

.hero-photo {
  background-image: url('https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?w=1400&q=80&auto=format&fit=crop');
  background-size: cover;
  background-position: center;
  filter: grayscale(0.2) contrast(1.05);
  -webkit-mask-image: linear-gradient(
    180deg,
    transparent 0%,
    #000 18%,
    #000 88%,
    transparent 100%
  );
  mask-image: linear-gradient(
    180deg,
    transparent 0%,
    #000 18%,
    #000 88%,
    transparent 100%
  );
}

.hero-photo::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    #0d0e10 0%,
    transparent 35%,
    transparent 100%
  );
}
</style>
